import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Fuel, 
  Settings,
  ClipboardList,
  Settings2,
  Sun,
  X,
  TrendingUp,
  LogOut,
  IndianRupee,
  FileText,
  Droplet,
  TableProperties,
  BookOpen,
  GitCompareArrows,
  Receipt,
  Wallet,
  MessageCircle,
  Landmark
} from 'lucide-react';
import clsx from 'clsx';

const navItems = [
  { name: 'Dashboard', icon: TrendingUp, path: '/' },
  { name: 'Meter & Dip Entry', icon: Sun, path: '/morning-readings' },
  { name: 'Fuel Rates', icon: IndianRupee, path: '/fuel-rates' },
  { name: 'Daily Statement', icon: FileText, path: '/daily-sheet' },
  { name: 'DSR', icon: TableProperties, path: '/dsr' },
  { name: 'Stock Difference', icon: GitCompareArrows, path: '/stock-difference' },
  // { name: 'Credit Sales', icon: FileText, path: '/credit-sales' },
  { name: 'Invoice', icon: Receipt, path: '/invoice' },
  { name: 'IOCL Indent', icon: Landmark, path: '/iocl-indent' },
  { name: 'Master Config', icon: Settings, path: '/master-config' },
  { name: 'Oil & Lubes Config', icon: Droplet, path: '/lube-config' },
  { name: 'Staff & Employees', icon: Users, path: '/employees' },
  // { name: 'Salary', icon: Wallet, path: '/salary' },
  { name: 'Creditors Config', icon: Users, path: '/creditors' },
  { name: 'Ledger & Accounts', icon: BookOpen, path: '/ledger' },
  { name: 'Settings', icon: Settings, path: '/settings' },
  { name: 'Staff Shortages', icon: ClipboardList, path: '/employee-shortages' },
  { name: 'WhatsApp', icon: MessageCircle, path: '/whatsapp', adminOnly: true },
  // { name: 'Reports', icon: ClipboardList, path: '/reports' },
  // { name: 'Govt. Statement', icon: TableProperties, path: '/stock-statement' },
];

const Sidebar = ({ isOpen, setIsOpen }) => {
  const [profile, setProfile] = useState({ pump_name: '', dealer_code: '' });

  useEffect(() => {
    fetch(`/api/settings/profile`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => res.json())
      .then(data => {
        if (!data.error) setProfile(data);
      })
      .catch(console.error);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-slate-900/50 z-20 md:hidden" 
          onClick={() => setIsOpen(false)}
        />
      )}
      
      {/* Sidebar container */}
      <aside className={clsx(
        'fixed md:static inset-y-0 left-0 z-30 w-64 bg-white border-r border-slate-200 transform transition-transform duration-300 ease-in-out flex flex-col',
        isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
      )}>
        <div className="h-16 flex items-center justify-between px-6 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-primary-600 flex items-center justify-center shrink-0">
              <Fuel className="text-white w-5 h-5" />
            </div>
            <div className="flex flex-col overflow-hidden">
              <span className="text-[17px] font-bold text-slate-900 tracking-tight leading-tight truncate uppercase">
                {profile.pump_name || 'PumpPro'}
              </span>
              <span className="text-[10px] font-bold text-slate-500 tracking-wider uppercase truncate">
                {profile.dealer_code ? `D.C. ${profile.dealer_code}` : 'Petrol Pump System'}
              </span>
            </div>
          </div>
          <button 
            onClick={() => setIsOpen(false)}
            className="md:hidden text-slate-500 hover:text-slate-700"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
          {navItems.filter(item => !item.adminOnly || localStorage.getItem('role') === 'admin').map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              className={({ isActive }) => clsx(
                'flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 group font-medium text-sm',
                isActive 
                  ? 'bg-primary-50 text-primary-600' 
                  : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
              )}
            >
              <item.icon className={clsx(
                'w-5 h-5 transition-colors',
                'group-hover:text-primary-600'
              )} />
              {item.name}
            </NavLink>
          ))}
        </nav>
        
        <div className="p-4 border-t border-slate-200">
          <button 
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 bg-red-50 text-red-600 hover:bg-red-100 py-2.5 rounded-xl transition-colors font-medium text-sm"
          >
            <LogOut className="w-4 h-4" />
            Sign Out
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
